import ButtonIcon from "#common/buttons/ButtonIcon"
import { SkeletonSquareGrid } from "#common/Skeleton"
import { useApi } from "#hooks/useApi"
import { UseReduxTraining } from "#training/redux/slice"
import { courseGet } from "#training/services/Api"
import AddIcon from "@mui/icons-material/Add"
import LinkIcon from "@mui/icons-material/Link"
import { Stack, Typography } from "@mui/material"
import IconButton from "@mui/material/IconButton"
import Tooltip from "@mui/material/Tooltip"
import MUIDataTable from "mui-datatables"
import React, { useMemo } from "react"
import CourseForm from "./CourseForm"
const CourseTable = () => {
	const params = useMemo(() => ({ table: true }), [])
	const { reloadCourses } = UseReduxTraining()
	const { data, loading } = useApi(courseGet, {
		autoFetch: true,
		params,
		reload: reloadCourses,
	})
	const columns = [
		{
			name: "nombre",
			label: "Nombre",
			options: {
				filter: false,
				sort: true,
			},
		},
		{
			name: "fecha_creacion",
			label: "Fecha Creación",
			options: {
				filter: false,
				sort: true,
			},
		},
		{
			name: "creado_por",
			label: "Creado por",
			options: {
				filter: true,
				sort: false,
				customBodyRender: (value) => {
					return <Typography>{value}</Typography>
				},
			},
		},
		{
			name: "plataforma",
			label: "Plataforma",
			options: {
				filter: true,
				sort: false,
			},
		},
		{
			name: " ",
			label: "",
			options: {
				filter: false,
				sort: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					const curso = data?.cursos[tableMeta?.rowIndex]

					return (
						<Stack direction={"row"} spacing={1}>
							<ButtonIcon
								icon={<LinkIcon />}
								title="Ir al curso"
								onClick={(event) => {
									event.stopPropagation()
									window.open(curso?.link, "_blank")
								}}
							/>
						</Stack>
					)
				},
			},
		},
	]

	//Datos DB------------------------------------------------------------->
	const [formEdit, setFormEdit] = React.useState(false)
	const [editData, setEditData] = React.useState({})
	const [tablaAct, setTablaAct] = React.useState(false)
	const [edit, setEdit] = React.useState(false)

	const handleOpen = () => {
		setEdit(false)
		setEditData(false)
		setFormEdit(true)
	}

	const options = {
		filter: true,
		download: false,
		print: false,
		selectableRows: "none",
		filterType: "dropdown",
		rowsPerPage: 10,
		// tableBodyHeight: "600px",

		viewColumns: false,
		customToolbar: () => (
			<Tooltip title="Agregar Curso" onClick={handleOpen}>
				<IconButton aria-label="addCourse">
					<AddIcon />
				</IconButton>
			</Tooltip>
		),
		onRowClick: (rowData, { dataIndex }) => {
			let datos = {}

			columns.forEach((column, index) => {
				datos[column["name"]] = rowData[index]
			})
			setEdit(true)
			setFormEdit(true)
			setEditData(data?.cursos[dataIndex] || {})
		},
	}

	if (loading) return <SkeletonSquareGrid height={"90vh"} />

	return (
		<React.Fragment>
			<MUIDataTable
				title={"Cursos"}
				data={data?.cursos ?? []}
				columns={columns}
				options={options}
			/>
			<CourseForm
				open={formEdit}
				setOpen={setFormEdit}
				id={editData?.id}
				tablaAct={tablaAct}
				setTablaAct={setTablaAct}
				edit={edit}
			/>
		</React.Fragment>
	)
}

export default CourseTable
